import { v4 as uuid } from 'uuid';

// Keep the original payload and key after an uncertain network result. Editing
// the form must not silently turn a retry into a second business operation.
export const intendedRequest = (ref, payload) => {
  const signature = JSON.stringify(payload);
  if (ref.current && ref.current.signature !== signature) {
    throw new Error('Une demande reste à vérifier. Réessayez avec les mêmes informations avant de les modifier.');
  }
  if (!ref.current) ref.current = { signature, payload: { ...payload, requestId: uuid() } };
  return ref.current.payload;
};

export const releaseRejectedRequest = (ref, error) => {
  // A definitive validation/business rejection made no write. Timeouts, server
  // errors, authentication errors and transport failures retain the key.
  if ([400, 404, 409, 422].includes(error?.status) && error?.code !== 'IDEMPOTENCY_CONFLICT') ref.current = null;
};